/* @flow */
import * as React from 'react';

import InputText from 'components/InputText';

type Props = {
  input: { onChange: () => any, onClick: (event: any) => any, value: any },
  meta: { error: string, touched: boolean },
  render: (props: any) => React.Node,
};

type State = {
  isEditing: boolean,
};

class FormEditableLabel extends React.PureComponent<Props, State> {
  state = {
    isEditing: false,
  };

  _handleOnBlur = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ isEditing: false });
  };
  _handleOnFocus = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    this.setState({ isEditing: true });
  };

  _handleInputClick = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    const {
      input: { onClick },
    } = this.props;
    if (typeof onClick === 'function') {
      onClick(event);
    }
  };

  render() {
    const { input, render, ...restProps } = this.props;
    const { onClick, value, ...restInput } = input;
    const { isEditing = false } = this.state;
    return isEditing ? (
      <InputText
        value={value}
        autoFocus={true}
        {...restInput}
        {...restProps}
        onBlur={this._handleOnBlur}
        onClick={this._handleInputClick}
      />
    ) : (
      render({ onClick: this._handleOnFocus, children: input.value })
    );
  }
}

export default FormEditableLabel;
